//#region Imports
import { SETTINGS_APP_PLATFORM, AUTH_HEADER, createMetaHeaders } from "@anydo/core";
//#endregion

// We don't return `Headers` object to make sure it can work in Node
export function createAuthHeaders(token?: string) {
  let headers: Record<string, string> = {
    "Content-Type": "application/json; charset=UTF-8",
    "X-Platform": String(SETTINGS_APP_PLATFORM),
    ...createMetaHeaders(),
  };

  // Also empty string isn't valid token
  if (token) {
    headers[AUTH_HEADER] = token;
  }

  return headers;
}
